// extracted by mini-css-extract-plugin
export const activeDot = "Carousel__activeDot__981uY";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const carousel = "Carousel__carousel__RH2X2";
export const carouselInner = "Carousel__carouselInner__wGYA-";
export const carouselSlideWrpaper = "Carousel__carouselSlideWrpaper__M0IuU";
export const dot = "Carousel__dot__r+c06";
export const dots = "Carousel__dots__EVRzm";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const invisible = "Carousel__invisible__ipYZj";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const slideWrapper = "Carousel__slideWrapper__bv0AL";
export const textCenter = "Carousel__textCenter__iAiUM";